'use client';

import useSWR from 'swr';
import Link from 'next/link';
import {usePathname} from 'next/navigation';
import {useContext} from 'react';

import CSS from './Toolbar.module.scss';
import Focus from '@/components/elements/Focus';
import Vector from '@/components/elements/vector/Vector';
import {
  isRejected,
  isVerified,
  isKYCGiftAcquirable
} from '../(authentication)/identity-verification/utils';
import {openGoftino} from '@/scripts/Goftino';
import {UserDataContext} from '@/context/UserData';
import {resolveRoute} from '@/lib/routes';
import {SettingsRoutes, getSettingsItemsBlock} from '@/lib/fetch/settings';
import {
  getKYCGift,
  CustomerLoyaltyProgramRoutes
} from '@/lib/fetch/customer-loyalty-program';

export default function Toolbar() {
  const {userData, isAuthenticated, token} = useContext(UserDataContext)!;
  const pathname = usePathname();

  const status = userData?.profile?.status;

  const {data: itemsBlock} = useSWR(
    SettingsRoutes.ItemsBlock,
    () => getSettingsItemsBlock(),
    {shouldRetryOnError: true}
  );

  const {data: kycGift} = useSWR(
    isAuthenticated &&
      token &&
      status &&
      !isRejected(status) &&
      !isVerified(status) &&
      !pathname.startsWith(resolveRoute('base.identity-verification'))
      ? [CustomerLoyaltyProgramRoutes.KYCGift, token]
      : null,
    () => getKYCGift(),
    {shouldRetryOnError: true}
  );

  const hasKYCGift = !!kycGift;
  const isKYCGiftDisabled = !!itemsBlock?.kycGift;
  const _isKYCGiftAcquirable = hasKYCGift && isKYCGiftAcquirable(kycGift);

  return (
    <section
      className={[CSS.toolbar, isAuthenticated ? CSS.aboveBottomBar : ''].join(
        ' '
      )}>
      {(_isKYCGiftAcquirable || // requested for the gift but yet not take it when still possible
        (!isAuthenticated && !isKYCGiftDisabled) ||
        (kycGift !== undefined && !hasKYCGift && !isKYCGiftDisabled)) && (
        <Focus>
          <Link
            href={resolveRoute('base.identity-verification.gift')}
            className={CSS.gift}
            tabIndex={-1}>
            <Vector name="giftBox" /> هدیه‌ات رو بگیر!
          </Link>
        </Focus>
      )}
      <Focus>
        <div onClick={openGoftino} className={CSS.goftino}>
          <Vector name="FiHeadphones" /> پشتیبانی
        </div>
      </Focus>
    </section>
  );
}
